import { render } from "./PostureReportView.vue?vue&type=template&id=f8430cca&scoped=true"
import script from "./PostureReportView.vue?vue&type=script&lang=js"
export * from "./PostureReportView.vue?vue&type=script&lang=js"

import "./PostureReportView.vue?vue&type=style&index=0&id=f8430cca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8430cca"]])

export default __exports__